import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import DecimalMonetario from "../../decimal";

export const PercentualFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <DecimalMonetario
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      campo={{ nome: campo.nome, tipo: "percentual", required: campo.required, modo }}
      onBlur={() => handleBlur(campo)}
      apenasLeitura={campo.apenasLeitura || false}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
